import type { ButtonHTMLAttributes, ReactNode } from "react";

type ButtonVariant = "primary" | "secondary" | "ghost" | "danger";
type ButtonSize = "default" | "small";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  children: ReactNode;
}

const VARIANT_CLASSES: Record<ButtonVariant, string> = {
  primary:
    "bg-edlab-green text-white border border-edlab-green shadow-[0_2px_4px_#00523614] hover:bg-edlab-green-dark",
  secondary:
    "border border-[#dfe4e9] bg-white text-[#455363] hover:border-[#c9d5d0] hover:bg-[#f1f5f4]",
  ghost: "border border-transparent bg-transparent text-edlab-green shadow-none hover:bg-edlab-green/5",
  danger: "border border-[#e4bfc4] bg-[#fff9fa] text-[#a73945] hover:bg-red-50",
};

const SIZE_CLASSES: Record<ButtonSize, string> = {
  default: "min-h-[39px] px-[14px] py-[10px] text-sm font-[550]",
  small: "min-h-[31px] px-[10px] py-[6px] text-xs font-[550]",
};

export function Button({
  variant = "primary",
  size = "default",
  className = "",
  children,
  ...props
}: ButtonProps) {
  return (
    <button
      type="button"
      className={[
        "inline-flex items-center justify-center gap-[7px] rounded-[9px] whitespace-nowrap transition-[background,border-color,transform,box-shadow] duration-150 disabled:cursor-not-allowed disabled:opacity-45",
        VARIANT_CLASSES[variant],
        SIZE_CLASSES[size],
        className,
      ].join(" ")}
      {...props}
    >
      {children}
    </button>
  );
}
